module.exports = __webpack_public_path__ + "img/lianminglogo.328e8899.png";